import React from "react";
import commonStyles from "@styles/CommonEditorPageLayout.module.css";
import { useNavigate } from "react-router-dom";
import Button from "@components/buttons/Button/Button";
import CheckIcon from "@components/display/CheckIcon/CheckIcon";
import styles from "./SetAdminSuccessPage.module.css";

const SetAdminSuccessPage: React.FC = () => {
    const navigate = useNavigate();

    const handleFinish = () => {
        navigate("/memorials");
    };

    return (
        <div className={commonStyles.container}>
            <h2>Invitation Sent</h2>
            <div className={commonStyles.messageContainer}>
                <CheckIcon />
                <p>An invitation email will be sent.</p>
                <p>User must accept the invitation to edit memorial.</p>
                <div className={styles.buttonContainer}>
                    <Button onClick={handleFinish}>Finish</Button>
                </div>
            </div>
        </div>
    );
};

export default SetAdminSuccessPage;
